﻿export class DateHelper {
    static getDate(date: Date): Date | null {
        
        if (date != null && date.toString().length > 0) {
            let userTimezoneOffset = date.getTimezoneOffset() * 60000;
            return new Date(date.getTime() - userTimezoneOffset);
        }
        return null;
    }
}